import { useCallback, useEffect, useState } from "react";
import { SubHeader } from "components/SubHeader";
import { Table } from "components/Table";
import { api } from "services/api";
import { CreateEdit } from "../CreateEdit";
import Matriz from "assets/icons/matriz.png";

export function List(props) {
  const tableParams = [
    {
      key: "date",
      label: "Data",
      filter: "date",
      type: "date",
      mobile: {
        type: "title",
      },
    },
    {
      key: "accommodations",
      label: "Número de Alojamentos",

      filter: "range",
      placeholder: "Número de Alojamentos",
      mobile: {
        type: "item",
      },
    },
    {
      key: "healthScore",
      label: "Escore Sanitário",
      placeholder: "Escore Sanitário",
      mobile: {
        type: "item",
      },
    },
  ];

  const [modalShow, setModalShow] = useState("");

  const [historicId, setHistoricId] = useState(null);

  const [customerName, setCustomerName] = useState("");

  const handleModal = useCallback(async (item) => {
    setHistoricId(item._id);
    setModalShow(true);
  }, []);

  useEffect(() => {
    const getCustomerName = async () => {
      const response = await api.get(
        `/connect/customer/${props.match.params.id}`
      );
      setCustomerName(response.data.name);
    };
    getCustomerName();
  }, [props.match.params.id]);

  return (
    <>
      {modalShow && (
        <CreateEdit
          show={modalShow}
          setShow={setModalShow}
          customer={props.match.params.id}
          id={historicId}
          onHide={() => {
            setModalShow(false);
            setHistoricId(null);
          }}
          location={props.location}
        />
      )}
      <SubHeader
        {...props}
        title={customerName}
        route="heavybroilerhistoric"
        breadcrumbs={[
          {
            label: customerName,
            to: "/connect/customer/" + props.match.params.id,
          },
          {
            label: "Matriz Pesada",
          },
          { label: "Histórico de Programas" },
        ]}
        icon={
          <img src={Matriz} style={{ width: "24px" }} alt="matriz pesada" />
        }
      />
      <Table
        cols={tableParams}
        editHandler={handleModal}
        emptyText={"Nenhum programa localizado!"}
        route={`/heavybroilerhistoric/list`}
        {...props}
      />
    </>
  );
}
